import { createSelector } from 'reselect';
import { ROOT_KEY } from './constants';

export const getProfilePageParameters = createSelector(
    state => state[ROOT_KEY],
    page => page,
);
